// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4541) return "static/chunks/4541-780839cca78d98bf.js";
	if (chunkId === 2259) return "static/chunks/2259-be3de2a48a916ab2.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"8774":"c7001e45","8970":"af3b0a73"}[chunkId] || chunkId) + "." + {"1933":"0c56aa4a97a71fe1","3954":"0ee53d2cee8c3408","8774":"6e723f458a0a352d","8970":"5db83efa6fb69253","8996":"daf14d3dfa173d0b","9800":"dcc176e3526825ad"}[chunkId] + ".js";
};